import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

import "@fontsource-variable/newsreader/standard.css";
import "@fontsource-variable/newsreader/standard-italic.css";
import "@fontsource-variable/urbanist/wght.css";
import "@fontsource-variable/urbanist/wght-italic.css";
import "@fontsource-variable/jetbrains-mono/wght.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
